import React, {Component} from 'react';
import config from 'config'

class RevLoanLimit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectaggreenow: false,
            id: "",
            text: "",
            todaydate: "",
            selectedlimit: 0,
            userdetail: {},
        }
        this.agreeCheck = this.agreeCheck.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    getValue(id) {
        fetch(`${config.REV_URL}/revloans/${id}`, {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((result) => {
                console.log('Success:', result.message);
                if (result.loan.agreeduser) {
                    let mylimit = 0;
                    if (result && result.loan && result.loan.requestsamount && result.loan.requestsamount.length > 0) {
                        let rra = result.loan.requestsamount.map(i => i.selectedlimit).reduce((a, b) => a + b, 0)
                        mylimit = result.loan.currentlimit - rra;
                    } else {
                        mylimit = result.loan.currentlimit;
                    }

                    let objuserdeatails = {name: result.loan.name, limit: mylimit};
                    this.setState({
                        id: result.loan._id,
                        userdetail: objuserdeatails,
                        todaydate: result.loan.todaydate,
                        revloanId: result.loan.revloanId
                    });
                } else {
                    window.location.replace(window.location.origin)
                    //console.log('sdf', window.location.origin)
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    agreeCheck() {
        this.setState({selectaggreenow: true})
        if (this.state.selectedlimit > 0) {
            fetch(`${config.REV_URL}/revloanslimitaccept/${this.state.id}`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({selectedlimit: this.state.selectedlimit, limit: this.state.userdetail.limit})
            })
                .then((response) => response.json())
                .then((result) => {
                    console.log('Success:', result.message);
                    //this.setState({text: result})
                    window.location.replace(window.location.origin);
                    this.setState({selectaggreenow: false})
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } else {
            alert("Please select Limit value. ")
        }
    }


    componentDidMount() {
        console.log("hjds",)
        this.getValue(this.props.match.params.id);
    }

    minusvalue(e) {
        e.preventDefault();
        if (this.state.selectedlimit > 0) {
            let mylimitselected = this.state.selectedlimit;
            this.setState({selectedlimit: mylimitselected - 1000})
        } else {
            alert("Your limit is 0 now.")
        }
    }


    plusvalue(e) {
        e.preventDefault();
        if (this.state.userdetail.limit > this.state.selectedlimit) {
            let mylimitselected = this.state.selectedlimit;
            this.setState({selectedlimit: mylimitselected + 1000})
        } else {
            alert("Your limit is fullfilled.")
        }
    }


    render() {
        return (
            <div>
                <div className="mainGridW">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-lg-12">
                                <div className="enterPa">
                                    <h3 className="newFontB">Revloan Confirmation Letter</h3>
                                    <div className="sater">

                                        <p>Name: {this.state.userdetail.name}</p>
                                        <p>Current Limit: {this.state.userdetail.limit}</p>
                                        <p className="center">Request Amount </p>

                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><button className="btn btn-sm"
                                                                                           onClick={(e) => {
                                                                                               this.minusvalue(e)
                                                                                           }}> - </button></span>
                                            </div>
                                            <input type="text" className="form-control" aria-label="Amount"
                                                   value={this.state.selectedlimit}/>
                                            <div className="input-group-append">
                                                <span className="input-group-text"><button className="btn btn-sm"
                                                                                           onClick={(e) => {
                                                                                               this.plusvalue(e)
                                                                                           }}> + </button></span>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div>
                                            <br/>
                                            <br/>
                                            <br/>
                                            <p>
                                                DATED: {this.state.todaydate}
                                            </p>
                                            <br/>
                                            <p>
                                                ARISTO SECURITIES P LIMITED
                                            </p>
                                            <p>
                                                Dear Sir / Madam,
                                            </p>

                                            <p>
                                                SUB: LOAN ACCOUNT NO: {this.state.revloanId}
                                            </p>

                                            <p>
                                                I, thankfully acknowledge the sanction of Revolving loan / overdraft
                                                facility in my favour amounting to
                                                Rs. {this.state.userdetail.limit} vide your letter
                                                dated {this.state.todaydate} in addition to above mentioned loan availed
                                                by me from your company.
                                            </p>
                                            <p>
                                                You are requested to kindly disburse a sum of
                                                Rs. {this.state.selectedlimit} in favour on early basis and oblige
                                            </p>
                                            <p>
                                                Thanking you,
                                            </p>
                                            <p>
                                                Yours faithfully
                                            </p>
                                            <p>
                                                {this.state.userdetail.name}
                                            </p>
                                        </div>


                                        <p className="center"></p>

                                        <div className="newPara">

                                            <br></br>

                                            <div>
                                                <button className="colorVbtn" onClick={() => this.agreeCheck()}
                                                        disabled={this.state.selectaggreenow}> Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default RevLoanLimit



// WEBPACK FOOTER //
// ./src/components/RevLoanLimit.js